import { render, staticRenderFns } from "./CreatePopup.vue?vue&type=template&id=527a0710"
import script from "./CreatePopup.vue?vue&type=script&lang=js"
export * from "./CreatePopup.vue?vue&type=script&lang=js"
import style0 from "./CreatePopup.vue?vue&type=style&index=0&id=527a0710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports